export default __webpack_public_path__ + "static/8987e4a6-1d32-4e4d-891e-aae853cb348c-52deb89793735df04d69f683d91c2806.woff";